import { useQuery } from 'react-query';

import PESService from 'App/services/PESService';

function useFetchPatientOtherDiagnoses(patientId) {
    return useQuery(
        ['patient', patientId, 'otherDiagnoses'],
        () => (!patientId ? null : PESService.getOtherCondition(patientId)),
        {
            retry: false,
            refetchInterval: false,
            refetchOnWindowFocus: false,
        }
    );
}

export default useFetchPatientOtherDiagnoses;
